export default "__VITE_ASSET__ZKTMu_W$__"